import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchNewestArticles } from '../../actions/articlesActions';
import useOnMount from '../../hooks/useOnMount';

const withNewestArticles = Component => (props) => {
	const { articlesReducer, dispatch } = props;
	const {
		newestArticles,
		newestArticlesLoading,
		newestArticlesError
	} = articlesReducer;

	useOnMount(() => {
		if(
			newestArticles === null
			&& !newestArticlesLoading
			&& !newestArticlesError
		) dispatch(fetchNewestArticles());
	});

	return (
		<Component
			title="Fréttir"
			loading={newestArticlesLoading || newestArticles === null}
			error={newestArticlesError}
			articles={newestArticles} />
	);
};

const mapStateToProps = ({ articlesReducer }) => ({
	articlesReducer,
});

const composedPageWrapper = compose(
	connect(mapStateToProps, null),
	withNewestArticles
);

export default composedPageWrapper;
